var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraggable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3335 6.6665C2.3335 6.11422 2.78121 5.6665 3.3335 5.6665H16.6668C17.2191 5.6665 17.6668 6.11422 17.6668 6.6665C17.6668 7.21879 17.2191 7.6665 16.6668 7.6665H3.3335C2.78121 7.6665 2.3335 7.21879 2.3335 6.6665ZM2.3335 13.3332C2.3335 12.7809 2.78121 12.3332 3.3335 12.3332H16.6668C17.2191 12.3332 17.6668 12.7809 17.6668 13.3332C17.6668 13.8855 17.2191 14.3332 16.6668 14.3332H3.3335C2.78121 14.3332 2.3335 13.8855 2.3335 13.3332Z",
    fill: "#115099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggable);
export default __webpack_public_path__ + "static/media/draggable.70c2be75.svg";
export { ForwardRef as ReactComponent };